<template>
    <component :is="iconComponent" class="size-[20px] text-[#7f7f7f]"></component>
</template>

<script setup>
import {
    Atom,
    AudioWaveform,
    Award,
    BadgePercent,
    Banknote,
    Blend,
    Blocks,
    BookMarked,
    Bot,
    Cable,
    ChartColumnIncreasing,
    ChartNetwork,
    CirclePlay,
    CircuitBoard,
    Cog,
    Combine,
    Container,
    File,
    FolderTree,
    GitCompareArrows,
    Hotel,
    Layers2,
    Merge,
    Notebook,
    PackageOpen,
    Plug,
    Repeat,
    Route,
    SquareStack,
    TrendingUp,
    Workflow,
} from 'lucide-vue-next';
import { computed } from 'vue';

const props = defineProps({ icon: { type: String, required: true } });

const iconComponent = computed(() => icons[props.icon]);

const icons = {
    atom: Atom,
    award: Award,
    banknote: Banknote,
    barGraph: ChartColumnIncreasing,
    blend: Blend,
    blocks: Blocks,
    bookmark: BookMarked,
    bot: Bot,
    building: Hotel,
    cable: Cable,
    chart: ChartNetwork,
    circuit: CircuitBoard,
    cog: Cog,
    combine: Combine,
    compare: GitCompareArrows,
    container: Container,
    file: File,
    folders: FolderTree,
    layers: Layers2,
    merge: Merge,
    notebook: Notebook,
    package: PackageOpen,
    percent: BadgePercent,
    play: CirclePlay,
    plug: Plug,
    repeat: Repeat,
    route: Route,
    stack: SquareStack,
    trending: TrendingUp,
    waveform: AudioWaveform,
    workflow: Workflow,
};
</script>
